import { PropsWithChildren } from 'react';
import useEffectOnce from 'react-use/lib/useEffectOnce';

import { useConfidenceCoreContext } from '@spotify/confidence-core-react';

import { useExtensions } from './shared/extensions';

export const WorkflowExtensionsInitializer = ({
  children,
}: PropsWithChildren) => {
  const workflowExtensions = useExtensions({ outlet: children });
  const { setConfig } = useConfidenceCoreContext();

  useEffectOnce(() => {
    setConfig({ workflowExtensions });
  });

  return <>{children}</>;
};
